import {
  Breadcrumbs as MuiBreadcrumbs,
  BreadcrumbsProps as MuiBreadcrumbsProps,
  Typography,
} from "@mui/material";

import { Link } from "@app/common/components/Link";

export interface BreadcrumbItem {
  label: string;
  link?: string;
}

interface BreadcrumbItemProps extends BreadcrumbItem {
  active: boolean;
}

interface BreadcrumbsProps extends MuiBreadcrumbsProps {
  items: BreadcrumbItem[];
}

const Breadcrumb = ({ active, label, link }: BreadcrumbItemProps) => {
  const item = (
    <Typography
      variant="caption"
      sx={{
        fontWeight: 500,
        color: active ? "shades.neutral.800" : "shades.neutral.500",
      }}
    >
      {label}
    </Typography>
  );

  if (link) {
    return (
      <Link to={link} sx={{ display: "flex", alignItems: "center" }}>
        {item}
      </Link>
    );
  }

  return item;
};

const Breadcrumbs = ({ items, ...props }: BreadcrumbsProps) => {
  return (
    <MuiBreadcrumbs
      aria-label="breadcrumbs"
      separator={<Typography variant="caption">/</Typography>}
      sx={{
        ".MuiBreadcrumbs-separator": {
          mx: 0.5,
          display: "flex",
          alignItems: "center",
        },
        ".MuiBreadcrumbs-li": { display: "flex", alignItems: "center" },
      }}
      {...props}
    >
      {items.map((item, i) => (
        <Breadcrumb
          key={item.label}
          {...item}
          active={i === items.length - 1}
        />
      ))}
    </MuiBreadcrumbs>
  );
};

export default Breadcrumbs;
